import React from 'react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import _ from 'lodash';
import { Tabs, Tab, ButtonBase } from '@mui/material';
import { Screen, Button, OrderPage, Message, Input, Switch, Select } from '../components';
import { fetchTrackTrace, cleanTrackTrace, setUser, changeTrackTraceSettings, trackTraceUploadLogo } from '../actions';
import { __, request } from '../functions';
import '../assets/styles/track_trace.css';
import {COUNTRY_NAMES, ALLOW_META_ESHOPS} from "../config";

/**
 * Track trace.
 */
class TrackTraceScreen extends Screen {
    /**
     * Title.
     *
     * @type {string}
     */
    title = __('Track & Trace');

    /**
     * Default state.
     *
     * @type {Object}
     */
    state = {
        loading: false,
        showTranslations: false,
        tab: 'confirm',
        settings: {},
    };

    translates = [
        'at',
        'be',
        'bg',
        'cy',
        'cz',
        'de',
        'dk',
        'ee',
        'en',
        'es',
        'fi',
        'fr',
        'gr',
        'hr',
        'hu',
        'ie',
        'it',
        'lt',
        'lu',
        'lv',
        'mt',
        'nl',
        'pl',
        'pt',
        'ro',
        'se',
        'si',
        'sk',
    ];

    /**
     * Komponenta bola pripojena.
     *
     * @return boolean
     */
    async componentDidMount() {
        if (super.componentDidMount()) {
            const { fetchTrackTrace } = this.props;

            // Nacitame nastavenia
            await fetchTrackTrace(this);

            const { track_trace } = this.props;

            this.setState({ settings: track_trace.settings });
        }

        return true;
    }

    /**
     * Komponenta bude odpojena.
     */
    componentWillUnmount() {
        const { cleanTrackTrace } = this.props;

        cleanTrackTrace();
    }

    /**
     * Event po zmene nastaveni.
     *
     * @param {string} param
     * @param {string} value
     */
    onChangeSetting(param, value) {
        let { settings, tab } = this.state;

        if (param === 'states') {
            settings = { ...settings, states: { ...settings.states, [tab]: { ...settings.states[tab], states: value } } };
        } else {
            settings = { ...settings, [param]: value };
        }

        this.setState({ settings });
    }

    /**
     * Event po zmene nastavenia textu.
     *
     * @param {string} country
     * @param {string} value
     */
    onChangeSettingText(country, value) {
        const { settings, tab } = this.state;

        this.setState({ settings: {
            ...settings,
            states: { ...settings.states, [tab]: { ...settings.states[tab], texts: { ...settings.states[tab].texts, [country]: value } } },
        } });
    }

    /**
     * Ulozenie nastaveni.
     */
    save() {
        const { changeTrackTraceSettings } = this.props;
        const { settings } = this.state;

        this.setState({ loading: true });

        changeTrackTraceSettings(this, settings);
    }

    /**
     * Nahratie loga.
     *
     * @param {Object} file
     */
    uploadLogo(file) {
        const { trackTraceUploadLogo } = this.props;

        request('/user-eshops/logo', file, 'FILE').then(response => {
            const { status, data } = response.data;

            if (status === 'error') {
                // Nepodarilo sa nahrat logo
                this.showSnackbar('error', __('Nepodarilo sa nahrať logo'));
                return;
            }

            // Nastavime logo
            trackTraceUploadLogo(data.url);
        });
    }

    /**
     * Rendrovanie.
     *
     * @returns {JSX.Element}
     */
    render() {
        const { track_trace, user } = this.props;
        const { loading, settings, tab, showTranslations } = this.state;

        if (_.isEmpty(track_trace) || _.isEmpty(settings)) {
            // Data nie su nacitane
            return this.renderLoading();
        }

        // Naformatujeme zoznam stavov
        const states = _.reduce(track_trace.states, (result, { id, name }) => ({ ...result, [id]: name }), {});

        const main_text_country = _.includes(this.translates, user.settings.market) ? user.settings.market : 'en';

        const eshop_name = _.has(user.eshops, user.eshop_id) ? user.eshops[user.eshop_id].name : '';

        return (
            <div className="track-trace">
                <div className="track-trace__settings">
                    <div className="track-trace__settings__title">{__('Nastavenia')}</div>
                    <div className="track-trace__settings__panels">
                        <div className="track-trace__settings__panels__panel">
                            <Message className="track-trace__settings__panels__panel__info" type="info">{__('Verejná objednávka obsahuje 4 základné stavy. Napárujte svoje eshopové stavy pre každý stav verejnej objednávky.')}</Message>
                            <Tabs
                                value={tab}
                                onChange={(event, tab) => this.setState({ tab })}
                                className="track-trace__settings__panels__panel__tabs"
                            >
                                <Tab label={__('Prijatá')} value="confirm" />
                                <Tab label={__('Spracováva sa')} value="processing" />
                                <Tab label={__('Odoslaná')} value="send" />
                                <Tab label={__('Doručená')} value="delivered" />
                            </Tabs>
                            <div className="track-trace__settings__panels__panel__tabs__settings">
                                <div className="track-trace__settings__panels__panel__tabs__settings__left">
                                    <Select
                                        label={__('Stavy objednávky v eshope')}
                                        options={states}
                                        value={settings.states[tab].states}
                                        onChange={value => this.onChangeSetting('states', value)}
                                        multiple
                                    />
                                    <div className="track-trace__settings__panels__panel__tabs__settings__info">{__('Zadajte stavy zo svojho eshopu ktoré reprezentujú stav verejnej objednávky.')}</div>
                                </div>
                                <div className="track-trace__settings__panels__panel__tabs__settings__right">
                                    <Input
                                        label={`${__('Doplňujúci text')} (${_.has(COUNTRY_NAMES, main_text_country) ? COUNTRY_NAMES[main_text_country] : main_text_country})`}
                                        value={_.has(settings.states[tab].texts, main_text_country) ? settings.states[tab].texts[main_text_country] : ''}
                                        onChange={value => this.onChangeSettingText(main_text_country, value)}
                                    />
                                    <div className="track-trace__settings__panels__panel__tabs__settings__info">{__('Váš doplňujúci text k stavu verejnej objednávky ktorý sa zobrazí zákazníkom.')}</div>
                                    <ButtonBase
                                        onClick={() => this.setState({ showTranslations: !showTranslations })}
                                    >{__('Preložiť')}</ButtonBase>
                                    {showTranslations ? _.map(this.translates, country => {
                                        if (country === main_text_country) {
                                            return null;
                                        }

                                        return <Input
                                            label={`${__('Doplňujúci text')} (${_.has(COUNTRY_NAMES, country) ? COUNTRY_NAMES[country] : country})`}
                                            value={_.has(settings.states[tab].texts, country) ? settings.states[tab].texts[country] : ''}
                                            onChange={value => this.onChangeSettingText(country, value)}
                                        />;
                                    }) : null}
                                </div>
                            </div>
                        </div>
                        <div className="track-trace__settings__panels__panel">
                            <ButtonBase className="track-trace__settings__panels__panel__upload">
                                {track_trace.logo === ''
                                    ? <div className="track-trace__settings__panels__panel__upload__text">{__('Kliknite alebo presuňte súbor (jpg, png, max. 5MB)')}</div>
                                    : <img src={`${track_trace.logo}?v=${Math.random()}`} alt="logo eshop" />}
                                <input type="file" onChange={event => this.uploadLogo(event.target.files[0])} />
                            </ButtonBase>
                            <div className="track-trace__settings__panels__panel__tabs__settings__info">{__('Logo eshopu ktoré sa zobrazí v záhlaví verejnej objednávky.')}</div>
                            <Input
                                label={__('Kontaktný email')}
                                value={settings.contact}
                                onChange={value => this.onChangeSetting('contact', value)}
                                type="email"
                            />
                            <div className="track-trace__settings__panels__panel__tabs__settings__info">{__('Kontaktný email na ktorý vás môže zákazník kontaktovať.')}</div>
                            <div className="track-trace__settings__panels__panel__switches">
                                {_.includes(ALLOW_META_ESHOPS, eshop_name) ? <Switch
                                    label={__('Automaticky uložiť odkaz do eshopu')}
                                    checked={_.has(settings, 'send_url_to_eshop') ? settings.send_url_to_eshop : false}
                                    onChange={checked => this.onChangeSetting('send_url_to_eshop', checked)}
                                /> : null}
                                {_.includes(ALLOW_META_ESHOPS, eshop_name) ? <div className="track-trace__settings__panels__panel__tabs__settings__info" style={{ marginBottom: '6px' }}>{__('Po vytvorení objednávky v eshope automaticky uloží odkaz na verejnú objednávku do meta dát v eshope. Názov meta je "public_url".')}</div> : null}
                                <Switch
                                    label={__('Povoliť reklamácie')}
                                    checked={settings.complaints}
                                    onChange={checked => this.onChangeSetting('complaints', checked)}
                                />
                                <Switch
                                    label={__('Povoliť storno')}
                                    checked={settings.cancel}
                                    onChange={checked => this.onChangeSetting('cancel', checked)}
                                />
                            </div>
                            {settings.cancel ? <Select
                                label={__('Stav objednávky po storne')}
                                options={states}
                                value={settings.cancel_state}
                                onChange={value => this.onChangeSetting('cancel_state', value)}
                            /> : null}
                        </div>
                    </div>
                    <Button
                        onClick={() => this.save()}
                        loading={loading}
                        className="track-trace__settings__button"
                        color="green"
                        disabled={this.isDemo()}
                    >{__('Uložiť')}</Button>
                    {!_.isEmpty(track_trace.order) ? <div className="track-trace__settings__part" /> : null}
                    {!_.isEmpty(track_trace.order) ? <Message type="warning">
                        <span>{__('Nižšie vidíte náhľad poslednej objednávky v eshope.')}</span>
                        <a href={`/orders/public/${track_trace.id}/${track_trace.token}`} target="_blank">{__('Zobraziť z pohľadu zákaznika')}</a>
                    </Message> : null}
                </div>
                {!_.isEmpty(track_trace.order) ? <OrderPage data={track_trace} target="_blank" /> : null}
                {this.renderSnackbar()}
            </div>
        );
    }
}

const stateToProps = ({ track_trace, user }) => ({ track_trace, user });

export default withCookies(connect(stateToProps, {
    fetchTrackTrace,
    setUser,
    cleanTrackTrace,
    changeTrackTraceSettings,
    trackTraceUploadLogo,
})(TrackTraceScreen));
